// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { DynProperty } from '@shared/commons/DynProperty';
import { AnalyzerLinesType } from '@shared/commons/cache/OptionMaster/OptionTrader/OptionAnalyzer/AnalyzerLinesType';
import { NumericUtils } from '@shared/utils/NumericUtils';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class OptionAnalyzerLineTableItem extends BaseItem {
    constructor(analyzerLine, lineType, sessionSettings) {
        super(sessionSettings);
        this.analyzerLine = analyzerLine;
        this.QuickTableEditingInfoMap[OptionAnalyzerLineTableItem.ACTIVE_COL_INDEX] = new QuickTableEditingInfo(DynProperty.BOOLEAN);
        const widthEditingInfo = new QuickTableEditingInfo(DynProperty.DOUBLE);
        widthEditingInfo.Min = 1;
        widthEditingInfo.Max = 10;
        widthEditingInfo.Inc = 1;
        widthEditingInfo.DecimalPlaces = 0;
        this.QuickTableEditingInfoMap[OptionAnalyzerLineTableItem.WIDTH_COL_INDEX] = widthEditingInfo;
        this.QuickTableEditingInfoMap[OptionAnalyzerLineTableItem.COLOR_COL_INDEX] = new QuickTableEditingInfo(DynProperty.COLOR);
        const valueEditingInfo = new QuickTableEditingInfo(DynProperty.DOUBLE);
        if (lineType === AnalyzerLinesType.TimeChange) {
            valueEditingInfo.Min = 0;
            valueEditingInfo.Max = NumericUtils.MAXVALUE;
            valueEditingInfo.Inc = 1;
            valueEditingInfo.DecimalPlaces = 0;
        }
        else {
            valueEditingInfo.Min = NumericUtils.MINVALUE;
            valueEditingInfo.Max = NumericUtils.MAXVALUE;
            valueEditingInfo.Inc = 0.01;
            valueEditingInfo.DecimalPlaces = 2;
        }
        this.QuickTableEditingInfoMap[OptionAnalyzerLineTableItem.VALUE_COL_INDEX] = valueEditingInfo;
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        return new ColumnData(value, value.toString());
    }
    getColumnValue(column) {
        switch (column) {
            case OptionAnalyzerLineTableItem.ACTIVE_COL_INDEX:
                return this.analyzerLine.isActive;
            case OptionAnalyzerLineTableItem.VALUE_COL_INDEX:
                return this.analyzerLine.value;
            case OptionAnalyzerLineTableItem.WIDTH_COL_INDEX:
                return this.analyzerLine.width;
            case OptionAnalyzerLineTableItem.COLOR_COL_INDEX:
                return this.analyzerLine.color;
            default:
                return undefined;
        }
    }
    ColumnCount() {
        return OptionAnalyzerLineTableItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = OptionAnalyzerLineTableItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetDataType(columnIndex) {
        return OptionAnalyzerLineTableItem.dataTypes[columnIndex];
    }
}
OptionAnalyzerLineTableItem.ACTIVE_COL_INDEX = 0;
OptionAnalyzerLineTableItem.VALUE_COL_INDEX = 1;
OptionAnalyzerLineTableItem.WIDTH_COL_INDEX = 2;
OptionAnalyzerLineTableItem.COLOR_COL_INDEX = 3;
OptionAnalyzerLineTableItem.columnsParams = [
    new ColumnParams('panel.optionAnalyzer.active', 16, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.optionAnalyzer.value', 65, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.optionAnalyzer.width', 43, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.optionAnalyzer.color', 26, QTAlignment.Left, TableTotalsVisibility.None, true, false)
];
OptionAnalyzerLineTableItem.dataTypes = [
    QuickTableComparingType.String,
    QuickTableComparingType.Int,
    QuickTableComparingType.Int,
    QuickTableComparingType.String
];
